import * as React from 'react';
import { Component } from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { translate } from "./Translate";
import formatter from "./formatter";
import LineChart from 'recharts/es6/chart/LineChart';
import Line from 'recharts/es6/cartesian/Line';
import XAxis from 'recharts/es6/cartesian/XAxis';
import YAxis from 'recharts/es6/cartesian/YAxis';
import CartesianGrid from 'recharts/es6/cartesian/CartesianGrid';
import ResponsiveContainer from 'recharts/es6/component/ResponsiveContainer';
import Tooltip from 'recharts/es6/component/Tooltip';
import Legend from 'recharts/es6/component/Legend';

const ResponsiveChartContainer = styled<any, any>(ResponsiveContainer)`
    ${propStyles};
`;

ResponsiveChartContainer.defaultProps = {
    fontSize: "xs"
};

@inject('dataStore')
@inject('translations')
@observer
class ChartLineChart extends Component<any, any> {
    render() {
        const { theme, dataStore, translations, config, data, xAxis, yAxis, series, getThemeColor, locale, fundCurrency } = this.props;

        return (
            <ResponsiveChartContainer
                aspect={3}
                {...theme.ResponsiveChartContainer}
            >
                <LineChart
                    data={data}
                >
                    {
                        config.grid &&
                        <CartesianGrid
                            {...config.grid}
                            stroke={getThemeColor(config.grid.stroke)}
                            fill={getThemeColor(config.grid.fill)}
                        />
                    }
                    {
                        config.tooltip &&
                        <Tooltip
                            cursor={{ strokeWidth: 0, fill: "rgba(0,0,0,0.05)" }}
                            {...config.tooltip}
                            labelFormatter={v =>
                                config.tooltip.labelFormat
                                    ? formatter(
                                        config.tooltip.labelFormat.type,
                                        locale,
                                        fundCurrency,
                                        config.tooltip.labelFormat.options,
                                        v
                                    )
                                    : v
                            }
                            formatter={v =>
                                config.tooltip.valueFormat
                                    ? formatter(
                                        config.tooltip.valueFormat.type,
                                        locale,
                                        fundCurrency,
                                        config.tooltip.valueFormat.options,
                                        v
                                    )
                                    : v
                            }
                        />
                    }
                    {
                        config.legend &&
                        <Legend
                            iconType="circle"
                            {...config.legend}
                        />
                    }
                    {
                        xAxis &&
                        <XAxis
                            label={xAxis.label}
                            dataKey={xAxis.dataKey}
                            tickLine={false}
                            {...xAxis}
                            tickFormatter={v => xAxis.format ? formatter(
                                xAxis.format.type,
                                locale,
                                fundCurrency,
                                xAxis.format.options,
                                v) : v}
                        />
                    }
                    {
                        yAxis &&
                        <YAxis
                            label={yAxis.label}
                            dataKey={yAxis.dataKey}
                            yAxisId="left"
                            orientation="left"
                            axisLine={false}
                            tickLine={false}
                            {...yAxis}
                            tickFormatter={v => yAxis.format ? formatter(
                                yAxis.format.type,
                                locale,
                                fundCurrency,
                                yAxis.format.options,
                                v) : v}
                        />
                    }
                    {
                        series.map((s, index) =>
                            <Line
                                key={`line-${s.dataKey}-${index}`}
                                name={translate(translations, s.label)}
                                dataKey={s.dataKey}
                                yAxisId="left"
                                dot={false}
                                type="natural"
                                {...s}
                                stroke={getThemeColor(s.color)}
                                isAnimationActive={!dataStore.isExpandAll}
                            />
                        )
                    }
                </LineChart>
            </ResponsiveChartContainer>
        );
    }
}

export default withTheme(ChartLineChart) as any;


// WEBPACK FOOTER //
// ./src/Components/ChartLineChart.tsx